import { render, staticRenderFns } from "./DataCardBig.vue?vue&type=template&id=1e5d2548&scoped=true"
import script from "./DataCardBig.vue?vue&type=script&lang=js"
export * from "./DataCardBig.vue?vue&type=script&lang=js"
import style0 from "./DataCardBig.vue?vue&type=style&index=0&id=1e5d2548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5d2548",
  null
  
)

export default component.exports